import { render, staticRenderFns } from "./accidentReportList.vue?vue&type=template&id=71a80673&scoped=true&"
import script from "./accidentReportList.vue?vue&type=script&lang=js&"
export * from "./accidentReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a80673",
  null
  
)

export default component.exports